<template>
  <div>
    <b-container>
        <b-row>
            <b-col sm="6" cols="12" v-for="user in users" v-bind:key="user.username">
                <b-card no-body border-variant="msstream" class="marginal">
                    <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">
                    <h5>{{user.username}} - C:{{user.client}}</h5>
                    </b-card-header>
                    <b-card-body>
                        <b-row>
                            <b-form-textarea
                            id="textarea"
                            v-model="user.js"
                            placeholder=""
                            rows="0"
                            max-rows="40"
                            ></b-form-textarea>
                        </b-row>
                        <b-row class="justify-content-around" style="margin-top:15px;">
                            <b-button variant="green" @click="updateUser(user)" ><i class="fas fa-check"></i> Update</b-button>
                            <b-button variant="quanteec" @click="userSelected = user.username; showModal('confirmDelete')" ><i class="fas fa-check"></i> Delete</b-button>
                        </b-row>

                    </b-card-body>
            
                </b-card>
            </b-col>
        </b-row>
    </b-container>

    <b-modal ref="confirmDelete" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>{{$ml.get('delete')}}</h3>
      </div>
      <p>{{$ml.get('confirmDeleteUser')}}</p>
      <b-row class="justify-content-around">

          <b-btn class="col-md-3 col-5" variant="quanteec" block @click="removeUser(userSelected);hideModal('confirmDelete')">{{$ml.get('yesDelete')}}</b-btn>

          <b-btn class="col-md-3 col-5" variant="mswarning" block @click="hideModal('confirmDelete')">{{$ml.get('cancel')}}</b-btn>

      </b-row>
  </b-modal>

  <b-modal ref="UpdateOk" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>{{$ml.get('successTitle')}}</h3>
      </div>
      <p>{{$ml.get('updateSuccess')}}</p>
      <b-row class="justify-content-around">

          <b-btn class="col-md-3 col-5" variant="green" block @click="hideModal('UpdateOk')">Ok</b-btn>

      </b-row>
  </b-modal>
  <b-modal ref="UpdateError" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>{{$ml.get('Error')}}</h3>
      </div>
      <p>{{$ml.get('updateErrorUser')}}</p>
      <b-row class="justify-content-around">

          <b-btn class="col-md-3 col-5" variant="quanteec" block @click="hideModal('UpdateError')">Ok</b-btn>

      </b-row>
  </b-modal>
  <b-modal ref="UpdateParseError" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>{{$ml.get('Error')}}</h3>
      </div>
      <p>{{$ml.get('jsonParseError')}}</p>
      <b-row class="justify-content-around">

          <b-btn class="col-md-3 col-5" variant="quanteec" block @click="hideModal('UpdateParseError')">Ok</b-btn>

      </b-row>
  </b-modal>
  </div>
</template>

<script>
import UserService from '@/services/user.service';

import { EventBus } from '@/event-bus.js';

var userService = new UserService();

export default {
  name: 'UserManagement',
  data: function() {
      return {
          users: [],
          userSelected: ''
      }
  },
  mounted() {
      this.getUsers();

  },
  methods:{
    removeUser(username) {
          userService.deleteUserById(username, this.$auth.token()).then((client) => {
              this.getUsers();
          }).catch((err) => {
              console.log(err);
          })
      },
    getUsers() {
        userService.getUsersAdmin(this.$auth.token()).then(users => {
            users.forEach((user) => {
                let js = JSON.stringify(user, null, 2);
                user.js = js;
            })
            this.users = users;
        }).catch(err => {

        })
    },
    updateUser(user) {
        let finalUser = {};
        try {
            finalUser = JSON.parse(user.js);
        } catch(err) {
            this.showModal('UpdateParseError')
            return;
        }
         
        userService.putUserAdmin(user.username, finalUser, this.$auth.token()).then(user => {
            let index = this.users.findIndex(x => x.username === user.username);
            let js = JSON.stringify(user, null, 2);
            user.js = js;
            this.users[index] = user;
            this.users = this.users.splice(0);
            this.showModal('UpdateOk')
        }).catch(err => {
            this.showModal('UpdateError')
        })
    },
    updateUserPassword(user) {
        let finalUser = {};
        try {
            finalUser = JSON.parse(user.js);
        } catch(err) {
            this.showModal('UpdateParseError')
            return;
        }
         
        userService.putUserAdmin(user.username, finalUser, this.$auth.token()).then(user => {
            let index = this.users.findIndex(x => x.username === user.username);
            let js = JSON.stringify(user, null, 2);
            user.js = js;
            this.users[index] = user;
            this.users = this.users.splice(0);
            this.showModal('UpdateOk')
        }).catch(err => {
            this.showModal('UpdateError')
        })
    },
    showModal(modal) {
      this.$refs[modal].show();
    },
    hideModal(modal) {
      this.$refs[modal].hide();
    },
  }
}
</script>
<style scoped lang="scss">



</style>